import { unformat } from 'utils/CustomFormatInput';

const digitValidator = (rut: number): string | number => {
	var multi = 0,
		S = 1;
	for (; rut; rut = Math.floor(rut / 10)) {
		S = (S + (rut % 10) * (9 - (multi++ % 6))) % 11;
	}
	return S ? S - 1 : 'K';
};

export const RutValidator = (rut: string): boolean => {
	let rutUnformat = unformat(rut);
	if (rut.length > 4) {
		let rutNumber = parseInt(rutUnformat.slice(0, -1));
		let digv = rutUnformat.slice(-1);

		if (digv !== 'K' && digv !== 'k') {
			return digitValidator(rutNumber) === parseInt(digv);
		} else {
			return digitValidator(rutNumber) === digv.toLocaleUpperCase();
		}
	} else {
		return false;
	}
};
